import { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Industries', to: '/industries' },
  { label: 'Process', to: '/process' },
  { label: 'Contact', to: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const headerBg = scrolled
    ? 'bg-white/95 backdrop-blur-xl border-b border-gray-200 shadow-sm'
    : isHome
      ? 'bg-[#F7F7F7] border-b border-transparent'
      : 'bg-white/80 backdrop-blur-md';

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${headerBg}`}>
      <nav className="w-full max-w-site mx-auto px-4 sm:px-6 flex items-center h-16 md:h-[4.5rem]">

        <Link to="/" className="group flex-shrink-0 mr-4">
          <img
            src="/logo.webp"
            alt="Blue Globe Media"
            className="h-12 md:h-14 w-auto max-w-[200px] sm:max-w-[230px] md:max-w-[260px] object-contain object-left transition-transform duration-500 group-hover:scale-105"
          />
        </Link>

        <div className="hidden md:flex flex-1 items-center justify-center gap-5 lg:gap-6">
          {NAV_LINKS.map(({ label, to }) => (
            <NavLink
              key={label}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? 'text-brand'
                    : 'text-gray-700 hover:text-brand-blue'
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        <div className="hidden md:flex flex-shrink-0 ml-4">
          <Link
            to="/contact"
            className="btn-primary text-sm px-5 py-2.5 hover:scale-105"
          >
            Get In Touch
          </Link>
        </div>

        <button
          className="md:hidden ml-auto text-gray-800"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-5 shadow-lg">
          {NAV_LINKS.map(({ label, to }) => (
            <NavLink
              key={label}
              to={to}
              onClick={() => setMenuOpen(false)}
              className="block py-2.5 text-gray-700 hover:text-brand-blue"
            >
              {label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="mt-3 block text-center btn-primary text-sm px-5 py-3"
          >
            Get In Touch
          </Link>
        </div>
      )}
    </header>
  );
}
